
/**
 * Import Vue.js
 */
import Vue from 'vue'

/**
 * Import App Components
 */
import './components'

/**
 * App Store
 * - VueX Statemanagement
 */
import store from './store/store'
import { mapActions, mapGetters } from 'vuex'

/**
 * Search Algo
 * - FuseJs
 */
import VueFuse from 'vue-fuse'
Vue.use(VueFuse)

/**
 * Init App and preload Store
 */
Vue.config.productionTip = false
new Vue({
  el: '#sprint_store',
  store,
  data: function () {
    return {
    }
  },
  created () {
    if (!this.location.ready) {
      this.getLocation().then(() => {
        this.getStations()
      })
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'getLocation', 'getStations'
    ])
  },
  computed: {
    ...mapGetters({
      location: 'location',
      stations: 'stations'
    })
  }
})


/**
 * Station Map
 */
if(document.getElementById("sprint_stations")){
    new Vue({
        el: '#sprint_stations',
        store,
        data: function () {
            return {
            }
        },
        created () {},
        mounted () {},
        methods: {},
        computed: {}
    })
}

/**
 * Search Widget
 */
window.addEventListener('load', () => {
    if (document.body.classList.contains('desktop-browser')) {
        console.log('desktop')
        if (document.getElementById("sprint_station_search_desktop")) {
            new Vue({
                el: '#sprint_station_search_desktop',
                store,
                data: function () {
                    return {}
                },
                created() {
                },
                mounted() {
                },
                methods: {},
                computed: {}
            })
        }
    } else if (document.body.classList.contains('mobile-browser')) {
        console.log('mobile')
        if (document.getElementById("sprint_station_search_mobile")) {
            new Vue({
                el: '#sprint_station_search_mobile',
                store,
                data: function () {
                    return {}
                },
                created() {
                },
                mounted() {
                },
                methods: {},
                computed: {}
            })
        }
    }
})

/**
 * Station Detail Map
 */
window.addEventListener('load', () => {
    googleMapsInit()
})

function googleMapsInit() {
    if (typeof google === 'object' && typeof google.maps === 'object') {

        function initialize(e) {
            let $map = $(e);
            let myLatlng = new google.maps.LatLng($map.data('lat'), $map.data('lng'));
            let mapOptions = {
                zoom: 15,
                center: myLatlng,
                disableDefaultUI: false,
                scrollwheel: false,
                disableDoubleClickZoom: true
            };

            let map = new google.maps.Map(e, mapOptions)

            let marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
            })
        }

        $('#map-canvas-footer').each(function (i, e) {
            google.maps.event.addDomListener(window, 'load', initialize(e))
        })
    }
}

$(document).ready(function() {
    $('.opening-hours li').eq(new Date().getDay()).addClass('today');
    console.log(new Date().getDay())
});



// WEBPACK FOOTER //
// ./Resources/Private/JavaScript/main.js